import React, { useEffect, useState } from 'react';
import style from './SocialShareButton.module.scss';
import FacebookShareButton from './FacebookShareButton/FacebookShareButton';
import TwitterShareButton from './TwitterShareButton/TwitterShareButton';

interface Props {
  title: string;
}

const SocialShareButton: React.FC<Props> = ({ title }) => {
  const [fullUrl, setFullUrl] = useState('');
  useEffect(() => {
    setFullUrl(window.location.href);
  }, []);

  return (
    <div className={style['sns-container']}>
      <FacebookShareButton fullUrl={fullUrl} title={title} />
      <TwitterShareButton fullUrl={fullUrl} title={title} />
    </div>
  );
};

export default SocialShareButton;
